var _dec, _dec2, _class2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Component from '@ember/component';
import { layout, tagName } from "@ember-decorators/component";
import templateLayout from '../../templates/components/power-calendar/nav';

let _class = (_dec = layout(templateLayout), _dec2 = tagName(''), _dec(_class2 = _dec2(_class2 = class _class2 extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "unit", 'month');

    _defineProperty(this, "format", 'MMMM YYYY');
  }

}) || _class2) || _class2);

export { _class as default };